import angular from 'angular'

type StateParams = {
  outcome?: string
  scheme?: string
  session_id?: string
}

export class UpgradeHandoffController {
  static $inject = ['$stateParams']

  outcome: string
  scheme: string
  sessionId: string

  constructor($stateParams: StateParams) {
    this.outcome = $stateParams.outcome ?? ''
    this.scheme = $stateParams.scheme ?? ''
    this.sessionId = $stateParams.session_id ?? ''
  }
}

angular.module('app').controller('UpgradeHandoffController', UpgradeHandoffController)
